import { Box, CircularProgress } from "@mui/material";

/** フォールバック コンポーネント */
const Fallback = () => {
  const sx = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // NOTE: 位置を上げたいなら低い数値に、位置を下げたいなら高い数値にする。
    height: "50vh",
  };
  return (
    <Box sx={sx}>
      <CircularProgress />
    </Box>
  );
};

export default Fallback;
